module.exports = __webpack_public_path__ + "img/img4.7ff2764a.jpg";